// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","container":"Footer_container__188QZ","text":"Footer_text__2zIhj","paws":"Footer_paws__1ozUv"};